<template>
  <div class="rib-list init">
    <div class="cps-page-top">
      <div class="jc-page-header">
        <el-page-header :title="$t('rib.rib')" />
        <div class="jc-box-action">
          <a target="_blank" :href="Config.ROUTETABLE_HELP_URL">
            {{ $t('rib.helpDoc') }}
          </a>
        </div>
      </div>
      <div class="jc-page-content">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar flex-display">
            <el-form class="jc-table-actionBar-item" :inline="true">
              <el-form-item>
                <el-button icon="jc-icon-refresh-line"
                           class="jc-button-icon"
                           @click="refreshList({})">
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-radio-group v-model="region" @change="regionChange">
                  <el-radio-button v-for="(area, index) in regions"
                                   :key="index"
                                   :label="area.region">
                    {{ area.regionName }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <el-form class="jc-box-table-search" :inline="true">
              <el-form-item>
                <el-button class="jc-button-icon operate-icon"
                           icon="el-icon-setting" @click="customVisible = true"
                           :title="$t('listPage.text.customList')">
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="jc-button-icon operate-icon"
                           icon="jc-icon-download"
                           @click="downloadList"
                           :title="$t('listPage.text.exportList')">
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="ribList"
                    :empty-text="$t('speechCraft.listEmptyText')"
                    v-loading="ribListLoading">
            <el-table-column :label="$t('rib.tableTitle.name')"
                             v-if="customInfo !== null && customInfo['name'].selected">
              <template scope="scope">
                <a href="javascript:void(0)"
                   @click="jumpToRibInfo(scope.row)">
                  {{ scope.row.name }}
                </a>
              </template>
            </el-table-column>
            <el-table-column :label="$t('rib.tableTitle.privateNetwork')" prop="vpcName"
                             v-if="customInfo !== null && customInfo['vpc'].selected">
              <template slot-scope="scope">
                {{ scope.row.vpcName | maybeEmpty }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('rib.tableTitle.type')" prop="typeName"
                             v-if="customInfo !== null && customInfo['type'].selected">
              <template slot-scope="scope">
                {{ transformType(scope.row.typeName) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('rib.tableTitle.createTime')" prop="createTime"
                             v-if="customInfo !== null && customInfo['datetime'].selected">
              <template slot-scope="scope">
                {{ scope.row.createTime }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div ref="footer"
         class="cps-page-footer block jc-container-table-actionBar"
         v-if="ribCount > 0">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="pageSizes"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="listTotal">
      </el-pagination>
    </div>
    <custom :visible.sync="customVisible"
            v-if="customVisible"
            :optionArr="optionArr"
            :type="type">
    </custom>
  </div>
</template>

<script>
import {
    NetworkTypeConstant
} from '@/common/Constants';
import { getYMD } from '@/common/dataHelper';
import custom from '@/components/common/custom/Custom';

export default {
  name: 'RibList',
  components: {
    custom
  },
  data() {
    return {
      ribListLoading: false,
      ribCount: 0, // 列表总数
      regions: [],
      ribList: [],
      type: 'routeTablesList', // 路由表自定义列表pageKey
      pageSize: 20,
      currentPage: 1,
      pageSizes: [20, 50, 100],
      region: '',
      customVisible: false,
      optionArr: [
        {
          // 名称
          label: this.$t('rib.tableTitle.name'),
          value: 'name'
        },
        {
          // 私有网络
          label: this.$t('rib.tableTitle.privateNetwork'),
          value: 'vpc'
        },
        {
          // 类型
          label: this.$t('rib.tableTitle.type'),
          value: 'type'
        },
        {
          // 创建时间
          label: this.$t('rib.tableTitle.createTime'),
          value: 'datetime'
        }
      ],
    };
  },
  methods: {
    /**
     * 转化表格中类型显示
     * @param type
     * @return String
     */
    transformType(type) {
      switch (type) {
        case 'DefaultRouteTable':
          return this.$t('rib.defaultRib');
        default:
          return type;
      }
    },
    /**
       * 带参数刷新列表
       * @param params
       */
    refreshList(params) {
      const defaultParams = {
        region: this.region,
        pageSize: this.pageSize,
        pageNumber: this.currentPage
      };
      const realParams = Object.assign({}, defaultParams, params);
      this.getRibList(realParams);
    },
    /**
       * 根据region刷新列表
       * 且初始化pageSize&pageNumber
       * @param region
       */
    regionChange(region) {
      this.region = region;
      this.pageSize = 20;
      this.currentPage = 1;
      const params = {
        region
      };
      this.refreshList(params);
    },
    /**
       * 下载列表
       */
    downloadList() {
      const params = {
        region: this.region,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      Ajax.download('GET', '/api/export/listRouteTables', params, { baseURL: '/cps_api' });
    },
    /**
       * 跳转路由表详情
       */
    jumpToRibInfo(row) {
      const regionName = this.getRegionName(row.region);
      this.$router.push(
        {
          path: '/routeTable/detail',
          query: {
            region: row.region,
            routeTableId: row.routeTableId,
            regionName
          }
        }
      );
    },
    /**
       * 获取用户自定义信息
       */
    getCustomInfo() {
      const params = {
        pageKey: this.type
      };
      Ajax.get('/api/usercenter/getCustomInfo', params)
        .then((res) => {
          if (res.data.customInfo) {
            this.$store.commit(
              'GET_CUSTOMINFO',
              { value: res.data.customInfo, type: this.type }
            );
          }
        });
    },
    /**
       * 获取区域
       */
    getRegions() {
      const params = {
        networkType: NetworkTypeConstant.VPC
      };
      Ajax.get('api/cps/getRegions', params).then((res) => {
        if (res.data) {
          res.data.regions.forEach((region, index) => {
            if (index === 0) {
              if (this.$route.query && this.$route.query.region) {
                this.region = this.$route.query.region;
              } else {
                this.region = region.region;
              }
            }
            const tempFormat = {};
            tempFormat.region = region.region;
            tempFormat.regionName = region.regionName;
            this.regions.push(tempFormat);
          });
        }
      }).catch()
        .finally(() => {
        this.refreshList({})
          }
        );
    },
    /**
       * 改变每页条数
       * 同时将当前所在页数置为第一页
       * @param size
       */
    handleSizeChange(size) {
      console.log('first--step');
      this.currentPage = 1;
      this.pageSize = size;
      const params = {
        pageSize: size,
        pageNumber: 1
      };
      this.refreshList(params);
    },
    /**
       * 改变当前页数
       * @param page
       */
    handleCurrentChange(page) {
      console.log('second--step');
      this.currentPage = page;
      const params = {
        pageNumber: page
      };
      this.refreshList(params);
    },
    /**
       * @param params
       * 获得rib列表
       */
    getRibList(params) {
      this.ribListLoading = true;
      Ajax.get('/api/cps/listRouteTables', params)
        .then((res) => {
          this.ribList = res.data.routeTables;
          this.ribCount = res.data.totalCount;
        })
        .finally(() => {
          this.ribListLoading = false;
        });
    },
    /**
     * 根据当前区域获取区域名称
     * 供详情页展示使用
     * @param region
     * @return {string}
     */
    getRegionName(region) {
      let regionName = '';
      this.regions.forEach((item) => {
        if (region === item.region) {
          regionName = item.regionName;
        }
      });
      return regionName;
    },
  },
  created() {
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
    this.getRegions();
  },
  computed: {
    /**
     * 返回自定义列的信息
     * @return {object}
     */
    customInfo () {
      return this.$store.state.customInfo[this.type];
    },
    /**
     * 返回查询到的总数
     * @return {number}
     */
    listTotal() {
      return this.ribCount;
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/paginationCommon.scss';
  @import '../../assets/scss/listComon.scss';
  .rib-list {
    a {
      font-size: 12px;
      color: #2C68FF;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/rib/RibList.vue